import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import EventRounded from '@mui/icons-material/EventRounded';
import SportsRounded from '@mui/icons-material/SportsRounded';

function formatMatchDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' })
    + ' at '
    + d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export default function MatchDetailsCard({ competition, round, date, referee }) {
  return (
    <Paper sx={{ p: 2, bgcolor: 'background.paper' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <InfoOutlined sx={{ color: 'text.secondary', fontSize: 18 }} />
        <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          Match Details
        </Typography>
      </Box>
      <Divider sx={{ mb: 1.5, borderColor: 'divider' }} />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
        {competition.icon && (
          <Box component="img" src={competition.icon} alt={competition.name}
            sx={{ width: 24, height: 24, objectFit: 'contain', flexShrink: 0 }} />
        )}
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>{competition.name}</Typography>
          {round && <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>{round.name}</Typography>}
        </Box>
      </Box>

      {date && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <EventRounded sx={{ color: 'text.secondary', fontSize: 20, flexShrink: 0 }} />
          <Typography variant="body2">{formatMatchDate(date)}</Typography>
        </Box>
      )}

      {referee && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <SportsRounded sx={{ color: 'text.secondary', fontSize: 20, flexShrink: 0 }} />
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>{referee.name}</Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>{referee.country}</Typography>
          </Box>
        </Box>
      )}
    </Paper>
  );
}
